import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.layout.gap.g5
  },
  item: {
    borderRadius: 'var(--border-radius-md)',
    outlineStyle: 'solid',
    outlineWidth: '1px',
    outlineColor: 'var(--color-primary-400)',
    paddingTop: theme.layout.padding.p5,
    paddingRight: theme.layout.padding.p10,
    paddingBottom: theme.layout.padding.p5,
    paddingLeft: theme.layout.padding.p10,

    transition: 'all .2s ease-in-out',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'color-mix(in srgb, var(--color-primary-500) 25%, transparent)'
    },

    '&.__selected': {
      backgroundColor: 'var(--color-primary-500)',
      color: 'var(--color-primary-050)',
      outlineColor: 'var(--color-primary-500)',
      outlineWidth: '2px'
    }
  }
}))

function DomainSelect ({ domains, selected, onSelect, processing }) {
  const classes = useStyles()
  const handleSelect = useCallback((v) => {
    if (processing) return

    onSelect(v)
  }, [onSelect, processing])

  useEffect(() => {
    if (!selected && domains.length) {
      handleSelect(domains.at(0).domain)
    }
  }, [domains, selected, handleSelect])

  return (
    <div className={classes.selectContainer}>
      {(domains || []).map((domain) => (
        <div key={domain.domain} className={clsx(classes.item, { __selected: selected === domain.domain })} onClick={() => handleSelect(domain.domain)}>
          {domain.name}
        </div>
      ))}
    </div>
  )
}

DomainSelect.propTypes = {
  domains: PropTypes.arrayOf(PropTypes.shape({
    domain: PropTypes.string,
    name: PropTypes.string
  })),
  selected: PropTypes.string,
  onSelect: PropTypes.func,
  processing: PropTypes.bool
}

export default DomainSelect
